import { Routes } from '@angular/router';

export const appRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./landing/landing.component').then((m) => m.LandingComponent),
  },
  {
    path: 'login/callback',
    loadComponent: () =>
      import('./login/callback/login-callback.component').then(
        (m) => m.LoginCallbackComponent,
      ),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login/login.component').then((m) => m.LoginComponent),
  },
];
